import { render, staticRenderFns } from "./to.vue?vue&type=template&id=47042770"
import script from "./to.vue?vue&type=script&lang=js"
export * from "./to.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports